module.exports = __webpack_public_path__ + "static/media/statement-account.0867fe44.svg";